import React from "react"

import SEO from "../components/seo"
//import styled from '@emotion/styled'

//components
import HIRE from "../components/Connect/hire"

import { motion, AnimatePresence } from "framer-motion"





const transition = { duration: 1, ease: [0.6, -0.05, 0.01, 0.9] }



const Connect = () => (
  <AnimatePresence
    exitBeforeEnter
    initial={{ opacity: 0 }}
    exit={{ opacity: 0 }}
    animate={{ opacity: 1 }}
  >
    <motion.div
      initial={{ opacity: 0 }}
      exit={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={transition}
    >
      <SEO title="Let's talk" />
      <HIRE />
     
    </motion.div>
  </AnimatePresence>
)

export default Connect
